













import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';

export default defineComponent({
  mounted() {
    // storeを初期化
    accessor.resetState();
  }
});
